import { ReactNode } from 'react';
import { GlobalStyles, ThemeProvider } from '@mui/material';

import darkTheme from '@/theme/darkTheme';

import { ROOT_CSS } from './tokens';

type AppThemeProviderProps = {
    readonly children: ReactNode;
};

export function AppThemeProvider({ children }: AppThemeProviderProps) {
    return (
        <ThemeProvider theme={darkTheme}>
            <GlobalStyles styles={ROOT_CSS} />
            {children}
        </ThemeProvider>
    );
}
